<script>
import featureMixin from "@/mixins/featureMixin";
import {mapActions, mapGetters, mapState} from "vuex";
import ParentComms from "@/classes/ParentComms";
import {RaddarEvent} from "@/features/raddar/store/raddar";
import {isArray} from "lodash";

function handleShoppingListEvent(event, data) {
	console.log('Shopping List Event:', data);
	const type = event.split('-').pop();
	if (data?.product?.sku || data?.sku) {
		data = {sku: data?.product?.sku || data?.sku, publicationId: data.publicationId}
	}
	ParentComms.SendEvent('shopping-list-event', {type, data});
}


export default {
	name: "RaddarSync",
	mixins: [featureMixin],
	data() {
		const slEvents = [];

		console.log('ShoppingList Events:', RaddarEvent.ShoppingList);

		for (let p in RaddarEvent.ShoppingList) {
			const event = RaddarEvent.ShoppingList[p];
			slEvents.push(event);
			slEvents.push(`iframe-event-${event}`);
		}

		return {
			featurePath: 'share',
			featureEvents: [
				'iframe-event-zoom',
				'iframe-event-orientation',
				'productRegionClick',
				...slEvents
			]
		}
	},
	created() {
		this.shoppingListLoad();
	},
	mounted() {
		ParentComms.SendEvent(RaddarEvent.Ping, {
			flyer: {
				publicationId: this.publicationId,
				storeId: this.storeId,
				dealId: this.dealId,
				lang: this.language
			}
		});
	},
	computed: {
		...mapState('scale', ['zoomLevel']),
		...mapState('shoppingList', ['shoppingList']),
		...mapGetters('landingPage', ['currentFlyer']),
		...mapGetters(['publicationId', 'storeId', 'dealId', 'language'])
	},
	methods: {
		...mapActions('scale', ['setZoomLevel']),
		...mapActions(['setColumnView']),
		...mapActions('shoppingList', {
			shoppingListAddBySku: 'skuAddToList',
			shoppingListClearAll: 'clearAll',
			shoppingListRemove: 'setRemoveFromList',
			shoppingListLoad: 'handleLocalStorage'
		}),

		/**
		 *
		 * @param {String} event
		 * @param data
		 */
		onFeatureEvent(event, data) {
			console.log('!!!Feature Event:', event, data)
			const value = data?.data;
			switch (event) {
				case 'iframe-event-zoom':
					if (!isNaN(value?.scale)) {
						const scale = (value.scale - 100) / 100;
						this.setZoomLevel(scale);
					}
					break;
				case 'iframe-event-orientation':
					this.setColumnView(value?.isColumnView)
					break;
				case 'productRegionClick':
					console.log('RaddarSync Product RegionClick:', data);
					ParentComms.SendEvent('dealClick', data?.product)
					break;
			}


			if (event.includes('iframe-event-shopping-list')) {
				this.handleShoppingListRequest(event, data);
			} else if (event.includes('shopping-list')) {
				handleShoppingListEvent(event, {...data, publicationId: this.publicationId});
			}
		},
		handleShoppingListRequest(event, data) {
			const evt = event.replace('iframe-event-', '');
			data = data?.data;
			switch (evt) {
				case RaddarEvent.ShoppingList.Add:
					//console.log('Adding Item to Shopping List:', data);
					this.shoppingListAddBySku(data?.sku);
					break;
				case RaddarEvent.ShoppingList.Remove:
					this.shoppingListRemove(data);
					break;
				case RaddarEvent.ShoppingList.Clear:
					this.shoppingListClearAll();
					break;
				case RaddarEvent.ShoppingList.List:
					if (isArray(data)) {
						data.forEach((item) => {
							if (item?.sku) this.shoppingListAddBySku(item.sku);
						})
					}
					break;
				case RaddarEvent.ShoppingList.GetList:
					handleShoppingListEvent(RaddarEvent.ShoppingList.List, [
						...this.shoppingList.map((prod) => {
							return {sku: prod?.sku}
						})
					])
					break;
			}
		}
	},
	watch: {
		zoomLevel(val) {
			ParentComms.SendEvent('zoom', {scale: val});
		}
	}

}
</script>

<template>
	<div class="raddar-sync"></div>
</template>

<style lang="scss" scoped>
.raddar-sync {
  display: none;
}
</style>
